import { helper } from '@ember/component/helper';
import { getSpecialDeviceAttributeConfig, isSpecialDeviceAttribute } from 'cio/app-models/conditions/device-attribute';

export function deviceConditionLabel([name]: string[]) {
  let label = name;
  if (isSpecialDeviceAttribute(name)) {
    label = getSpecialDeviceAttributeConfig(name)!.label;
  }
  return label;
}

export default helper(deviceConditionLabel);
